module.exports = __webpack_public_path__ + "img/scenes_1.31fe95fe.png";